import React from 'react'

import { OptionsMenu } from '../data-card/data-card-parts'

export default ({
  messageId,
  deleteUnreadMessage
}) => (
  <OptionsMenu optionItems={[{name: 'Delete', action: deleteUnreadMessage}]} />
)



// WEBPACK FOOTER //
// ./src/components/messages/message-card-options.js